import { AxiosHeaders } from 'axios';
import ApiUtilities from '../../ApiUtilities/index.js';
import AuthStrategy from '../../enums/AuthStrategyEnum.js';
import BaseAuthStrategy from './BaseAuthStrategy.js';

class NPCustomSlideAuthStrategy extends BaseAuthStrategy {
  static TOKEN_STORAGE = {};
  constructor(options) {
    super();
    this.options = options;
  }
  get accessToken() {
    return NPCustomSlideAuthStrategy.TOKEN_STORAGE[this.options.tokenDomain];
  }
  set accessToken(token) {
    NPCustomSlideAuthStrategy.TOKEN_STORAGE[this.options.tokenDomain] = token;
  }
  async fetchAccessToken() {
    const {
      fetcher
    } = ApiUtilities({
      authConfig: {
        strategy: AuthStrategy.NP_TOKEN,
        options: this.options.authOptions
      }
    });
    const response = await fetcher('GET', `${this.options.apiPath}custom_slides/${this.options.slideId}/jwt`, {});
    return response.data?.payload?.jwt;
  }
  async requestInterceptor(config) {
    // Pre-fetch the token if it's not already in the storage.
    if (!this.accessToken) {
      this.accessToken = await this.fetchAccessToken();
    }
    const headers = new AxiosHeaders(config.headers);
    headers.Authorization = this.accessToken;
    return {
      ...config,
      withCredentials: true,
      headers
    };
  }
}

export { NPCustomSlideAuthStrategy as default };
//# sourceMappingURL=NPCustomSlideAuthStrategy.js.map
